'use client';

import { Building2, LogOut, ShieldCheck, Users } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { apiPost } from '@/lib/api/client';
import { cn } from '@/lib/utils';
import type { AdminMe } from '@/types/admin';

const NAV_ITEMS = [
  { href: '/admin/organizations', label: '組織', icon: Building2 },
  { href: '/admin/users', label: 'ユーザー', icon: Users },
  { href: '/admin/platform-admins', label: 'スタッフ', icon: ShieldCheck },
];

interface AdminNavProps {
  me: AdminMe;
}

export function AdminNav({ me }: AdminNavProps) {
  const pathname = usePathname();

  const handleLogout = async () => {
    await apiPost('/auth/admin/logout', undefined, {
      skipAuthHeaders: true,
      skipAuthRedirect: true,
    });
    // ログアウト後は React state/Context を確実にリセットするためフルナビゲーションにする
    // eslint-disable-next-line @next/next/no-location-assign-relative-destination
    window.location.href = '/admin/login';
  };

  return (
    <aside className="flex w-56 flex-col border-r border-gray-200 bg-white">
      <div className="border-b border-gray-200 px-4 py-4">
        <p className="text-sm font-semibold text-gray-900">運営コンソール</p>
        <p className="mt-0.5 truncate text-xs text-gray-500">{me.Email}</p>
      </div>
      <nav className="flex-1 space-y-1 px-2 py-3">
        {NAV_ITEMS.map((item) => {
          const active = pathname.startsWith(item.href);
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              href={item.href}
              className={cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm',
                active ? 'bg-blue-50 font-medium text-blue-700' : 'text-gray-700 hover:bg-gray-50'
              )}
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>
      <div className="border-t border-gray-200 p-2">
        <button
          type="button"
          onClick={handleLogout}
          className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-600 hover:bg-gray-50"
        >
          <LogOut className="h-4 w-4" />
          ログアウト
        </button>
      </div>
    </aside>
  );
}
